import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { MaintenanceService, MaintenanceModule } from '../services/maintenance.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  private readonly maintenanceService = inject(MaintenanceService);
  private readonly router = inject(Router);

  canActivate(): boolean | UrlTree {
    try {
      if (this.maintenanceService.isGlobalActive()) {
        return this.router.createUrlTree(['/maintenance']);
      }
      return true;
    } catch {
      return true;
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean | UrlTree {
    try {
      // Check global maintenance first
      if (this.maintenanceService.isGlobalActive()) {
        return this.router.createUrlTree(['/maintenance']);
      }

      // Check per-module maintenance via route data
      const moduleKey = childRoute.data?.['maintenanceKey'] as MaintenanceModule | undefined;
      if (moduleKey && this.maintenanceService.isModuleUnderMaintenance(moduleKey)) {
        return this.router.createUrlTree(['/maintenance']);
      }

      return true;
    } catch {
      return true;
    }
  }
}
